import { Address } from './address.model';

export class AddressHistory {
    address: Address;
	tenure: string = '';
	years_at_address: number;
	months_at_address: number;
}
